import * as httpStatus from './smartpak/httpstatus.js';
import * as url from './smartpak/url.js';
import ajaxRequestManager from './views/shared/ajaxrequestmanager.js';
import { bindDatasetListener } from './utils/events.js';
import chat from './smartpak/chat.js';
import client from './api/apiclient.js';
import customerInfo from './controls/customerinfo.js';
import listenForElementWithModalAttributes from './smartpak/lazymodal.js';
import login from './views/customeraccount/login.js';
import manageFirstVisit from './views/shared/managefirstvisit.js';
import modal from './smartpak/modal.js';
import namespace from './smartpak/smartpak.js';
import observeImages from './lazyloadimages.js';
import product from './api/product.js';
import recentlyViewedProducts from './smartpak/recentlyviewedproducts.js';
import recipient from './api/recipient.js';
import { overrideRibbonWithContent, requestSitewideRibbon, rotatingMessageRibbon } from './views/shared/ribbon.js';
import searchBox from './views/shared/search.js';
import spree from './views/spree/spree';
import zipcode from './views/shared/zipcode.js';
import discover from './urlparameterdiscovery/urlparameterdiscovery.js';
import navigationClickEventListeners from './vendor/googletagmanager/spevents/navigationclickeventlisteners.js';


const api = namespace('api');

api.client = client;
api.product = product;
api.recipient = recipient;
window.smartPak.customerInfo = customerInfo;
window.smartPak.url = url;
window.smartPak.HTTP_STATUS_OK = httpStatus.HTTP_STATUS_OK;
window.smartPak.HTTP_STATUS_CREATED = httpStatus.HTTP_STATUS_CREATED;
window.smartPak.HTTP_STATUS_NOCONTENT = httpStatus.HTTP_STATUS_NOCONTENT;
window.smartPak.HTTP_STATUS_BADREQUEST = httpStatus.HTTP_STATUS_BADREQUEST;
window.smartPak.HTTP_STATUS_UNAUTHORIZED = httpStatus.HTTP_STATUS_UNAUTHORIZED;
window.smartPak.HTTP_STATUS_NOTFOUND = httpStatus.HTTP_STATUS_NOTFOUND;
window.smartPak.HTTP_STATUS_INTERNALSERVERERROR = httpStatus.HTTP_STATUS_INTERNALSERVERERROR;
window.smartPak.HTTP_STATUS_SERVICEUNAVAILABLE = httpStatus.HTTP_STATUS_SERVICEUNAVAILABLE;
window.smartPak.login = login;
window.smartPak.recentlyViewedProducts = recentlyViewedProducts;
window.smartPak.zipCode = zipcode;

ajaxRequestManager.init();

namespace('ui').modal = modal;

function onDocReady() {
    customerInfo.init();

    const getCustomerInfo = () => new Promise(res => {
        customerInfo.getCustomerInfo().done(response => res(response));
    });

    Promise.all([getCustomerInfo(), requestSitewideRibbon()]).then(([customerInfoResponse, ribbonResponse]) => {
        if (customerInfoResponse && customerInfoResponse.status === httpStatus.HTTP_STATUS_OK) {
            zipcode.init(customerInfoResponse.content.initialUserLocation, smartPak.page.isMobile());

            if (!ribbonResponse) {
                rotatingMessageRibbon(document.querySelector('#site-ribbon > ul'));
            }
        }

        if (ribbonResponse) {
            overrideRibbonWithContent(ribbonResponse);
        }
    });

    searchBox();
    observeImages();
    bindDatasetListener();
    manageFirstVisit();
    listenForElementWithModalAttributes();
    login.listenForAuthEvents();

    const hasFullSiteHeader = () => document.querySelector('.site-header');

    if (hasFullSiteHeader()) {
        navigationClickEventListeners();
    }
}

if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    onDocReady();
} else {
    window.addEventListener('DOMContentLoaded', onDocReady);
}

function showUpdateMessageOnLegacyBrowsers() {
    if (/MSIE|Trident/.test(navigator.userAgent)) {
        const $warning = document.getElementById('ieWarning');

        if ($warning) {
            $warning.classList.remove('jsHide');
        }
    }
}

window.addEventListener('load', function () {
    if (smartPak.cdProfileCookie && smartPak.cdProfileCookie.qualifiesForSuggestions) {
        import('./views/smartsuggestion/smartsuggestions.js').then(({ default: smartSuggestions }) =>
            smartSuggestions.init()
        );
    }

    discover(location.search, {
        allowAutoApplyPromo: smartPak.pageData?.allowAutoApplyPromo
    });

    if (smartPak.pageData && smartPak.pageData.spreeEnabled) {
        spree();
    }


    document.addEventListener(
        'click',
        function (e) {
            if (/footerEmailBtn/gi.test(e.target.id) || e.target.classList.contains('emailOptIn')) {
                e.preventDefault();

                const loadEmailForm = () => {
                    import('./showemailmodal.js').then(({ default: showEmailModal }) => {
                        showEmailModal(e);
                    });
                };

                if (!window.ko) {
                    const script = document.createElement('script');

                    script.async = true;
                    script.type = 'text/javascript';
                    script.onload = loadEmailForm;
                    script.src = '/jsscripts/jquery/knockout/knockout-3.5.1.js';
                    document.getElementsByTagName('head')[0].appendChild(script);
                    return;
                }

                loadEmailForm();
            }
        },
        true
    );

    chat.init();
    prefillUserEmail();
    showUpdateMessageOnLegacyBrowsers();

    function prefillUserEmail() {
        const $email = document.getElementById('email-subscribe');

        if ($email && !$email.value && smartPak?.cdProfileCookie?.CustomerEmail) {
            $email.value = smartPak.cdProfileCookie.CustomerEmail;
            $email.readOnly = true;
        }
    }
});
